"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _PopupScreen = _interopRequireDefault(require("../../02_molecules/PopupScreen"));

var _AddPassengerWidget = _interopRequireDefault(require("../../02_molecules/AddPassengerWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MobileAddPassengerPopup = function MobileAddPassengerPopup(_ref) {
  var sdk = _ref.sdk,
      _ref$onAdd = _ref.onAdd,
      onAdd = _ref$onAdd === void 0 ? function () {} : _ref$onAdd,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      t = _ref.translator,
      translatorForNamespace = _ref.translatorForNamespace;
  return /*#__PURE__*/_react["default"].createElement(_PopupScreen["default"], {
    title: t('Add passenger'),
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_AddPassengerWidget["default"], _extends({
    sdk: sdk,
    onAdd: onAdd,
    onBack: onBack,
    translatorForNamespace: translatorForNamespace
  }, {
    showAllFields: false
  })));
};

var _default = MobileAddPassengerPopup;
exports["default"] = _default;